import { useEffect } from 'react';

import { motion } from 'motion/react';
import { Outlet, useLocation } from 'react-router';
import { twMerge } from 'tailwind-merge';

import { useCustomizationStore } from '@/widgets/widgets-slider';

// TODO fix fsd

import { cn, useViewportStore } from '@/shared/lib';
import { AppImage, Skeleton } from '@/shared/ui';

import {
  BACKGROUND_REMOVED_ROUTES,
  MOBILE_HEADER_BUTTONS_BY_ROUTES,
} from '../../config';
import { useSplashScreenStore } from '../../model';
import DashboardHeader from '../DashboardHeader';
import { MobileDashboardHeader } from '../MobileDashboardHeader';

const RootLayoutContent = () => {
  const background = useCustomizationStore((state) => state.background);
  const isDesktop = useViewportStore((state) => state.isDesktop);
  const isShowSplashScreen = useSplashScreenStore(
    (state) => state.isShowSplashScreen,
  );
  const setIsShowSplashScreen = useSplashScreenStore(
    (state) => state.setIsShowSplashScreen,
  );

  useEffect(() => {
    if (isDesktop || !isShowSplashScreen) return;
    setIsShowSplashScreen(false);
  }, [isDesktop]);

  useEffect(() => {
    if (!isShowSplashScreen) return;
    const timeout = setTimeout(() => {
      setIsShowSplashScreen(false);
    }, 3000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const editingBackground = useCustomizationStore(
    (state) => state.editingBackground,
  );

  const { pathname } = useLocation();

  const isBackgroundDefault = BACKGROUND_REMOVED_ROUTES.includes(pathname);
  const isAccRoute = pathname.includes('account');

  return (
    <div
      className={cn(
        'max-w-layout mx-auto flex h-full w-full flex-col items-center',
        {
          // '!bg-surface-00': isBackgroundDefault,
          '!bg-none': isBackgroundDefault,
          '!bg-splash-screen': isShowSplashScreen,
        },
      )}
    >
      <motion.div
        initial={isDesktop ? { opacity: 0 } : false}
        animate={isDesktop ? { opacity: 1 } : false}
        transition={{ duration: 0.5, delay: 1.5, ease: 'easeOut' }}
      >
        <AppImage
          fallback={<Skeleton className="h-full w-full" />}
          src={editingBackground ?? background}
          alt=""
          className="fixed inset-0 h-full w-full object-cover"
        />
      </motion.div>

      {isDesktop ? (
        <DashboardHeader />
      ) : (
        <MobileDashboardHeader
          actionButtons={MOBILE_HEADER_BUTTONS_BY_ROUTES}
        />
      )}

      <motion.main
        onAnimationComplete={() => {
          if (isShowSplashScreen) setIsShowSplashScreen(false);
        }}
        initial={isDesktop ? { opacity: 0 } : false}
        animate={isDesktop ? { opacity: 1 } : false}
        transition={{ duration: 0.5, delay: 3, ease: 'easeOut' }}
        className={twMerge(
          'relative z-40 flex h-full w-full flex-col items-center overflow-x-hidden pb-[240px] md:pt-20',
          isAccRoute && '!w-fit',
        )}
      >
        <Outlet />
      </motion.main>
    </div>
  );
};

export default RootLayoutContent;
